<sh-grid *ngIf="assetsCardDetails.length > 0">
  <div columns="3" col-m="6" col-s="12" *ngFor="let asset of assetsCardDetails">
    <app-asset-card [asset]="asset" (click)="fetchCardDetails()"></app-asset-card>
  </div>
</sh-grid>